import { Flex, Stack, Text } from '@mantine/core'

import { useShareContent } from '../ShareChart/hooks'
import { ShareModalContentProps, SocialType } from '../utils'
import styles from './index.module.css'
import TokenPriceSHareInfo from './TokenPriceShareInfo'
import {
  getBackgroundImage,
  LION_DESC_COLOR,
  SHARE_CHART_BACKGROUND,
  SHARE_CONTENT_SIZE_MAP,
} from './utils'

export default function InsShareContent({
  shareType,
  curTimeRange,
  contentContainerRef,
  currentCoinPrices,
}: ShareModalContentProps) {
  const BackgroundImage = getBackgroundImage(SocialType.instagram, shareType)
  const { shareContent, lionDsc } = useShareContent({
    shareType,
    curTimeRange,
    currentCoinPrices,
  })
  return (
    <Flex
      ref={contentContainerRef}
      {...SHARE_CONTENT_SIZE_MAP[SocialType.instagram]}
      pos="relative"
      justify={'center'}
      pt={112}
      gap={0}
    >
      <Stack align={'center'}>
        <TokenPriceSHareInfo
          change={currentCoinPrices?.usd_price_change ?? 0}
          timeRange={curTimeRange}
        />
        <Flex w={1000} h={1000} bg={SHARE_CHART_BACKGROUND}>
          {shareContent}
        </Flex>
        <Text mt={65} className={styles.lionDsc} c={LION_DESC_COLOR} style={{ fontSize: 62 }}>
          {lionDsc}
        </Text>
      </Stack>
      <BackgroundImage className={styles.shareBackground} />
    </Flex>
  )
}
